import { getFilterValuesForRequest } from "~/helpers/get-filter-values-for-request";
import { IUseRequestHandlerActionsKind } from "~/types/products-request-handler";

import { IHandleLoadButton } from "../types";

import { getPageNumberFromMap } from "./get-page-number-from-map";

export const handleLoadMore = async ({
  getMoreItems,
  efq,
  q,
  brUid2,
  brRefUrl,
  appliedFilters,
  isShopFilter,
  currentStore,
  activeSortingParam,
  pageSize,
  itemsMap,
  productsMarkerId,
  setProductsMarkerId,
  locale,
  dispatchRequest,
}: IHandleLoadButton): Promise<void> => {
  if (productsMarkerId) {
    setProductsMarkerId(null);
  }
  const derivedPageNumber = getPageNumberFromMap(itemsMap, "max");
  const filterValues = getFilterValuesForRequest(
    appliedFilters,
    isShopFilter,
    currentStore?.id,
  );

  dispatchRequest({
    type: IUseRequestHandlerActionsKind.SET_DIRECTION,
    payload: { direction: "next" },
  });

  getMoreItems({
    variables: {
      efq,
      q: q ?? "",
      start: derivedPageNumber * pageSize,
      rows: pageSize,
      shouldConcat: true,
      fq: filterValues,
      sort: activeSortingParam,
      locale,
      brUid2,
      brRefUrl,
    },
  });
};
